var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"my-2"},[_c('b-card',{staticClass:"link",attrs:{"overlay":"","img-src":'https://api.kllaar.com/public/udemy/'+_vm.cover,"img-alt":_vm.title,"text-variant":"white"},on:{"click":function($event){return _vm.openLink(_vm.href)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28ed8afe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/#public/curse/components/home/ExternalCourseItem.vue
// module id = null
// module chunks = 